<template>
  <section>
    <div
      :class="customClases"
      :data-e2e="AICypressAttribute.views.CLARA_LEGAL_REASONING_SOURCE_CONTENT_QUESTION"
    >
      {{ displayContent.question }}
    </div>
    <div
      class="has-text-weight-normal has-text-grey-dark"
      :class="{ 'm-t-5': !lighterText }"
      :data-e2e="AICypressAttribute.views.CLARA_LEGAL_REASONING_SOURCE_CONTENT_ANSWER"
    >
      {{ $t('ai.answer') }}: {{ displayContent.answer }}
    </div>
  </section>
</template>

<script>
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraLegalReasoningSourceContent',
  props: {
    content: {
      String,
      required: true
    },
    lighterText: {
      type: Boolean,
      default: false
    }
  },
  static: {
    AICypressAttribute
  },
  computed: {
    displayContent() {
      return JSON.parse(this.content);
    },
    customClases() {
      return this.lighterText
        ? 'has-text-grey has-text-weight-normal'
        : 'has-text-grey-darker has-text-weight-semibold';
    }
  }
};
</script>
